import React from "react";

export const HowEditTrackInAlbum: React.FC = () => {
  return <div id={"HowEditTrackInAlbum"}>
    <h2>
      Как отредактировать трек в опубликованном альбоме
    </h2>
    <ul className={"list-disc"}>
      <li>
        Откройте альбом и нажмите Черновик
      </li>
      <li>
        Перейдите в Трек-лист, найдите трек, в который необходимо внести изменения, и отредактируйте его
      </li>
      <li>
        Сохраните изменения и нажмите кнопку Опубликовать
      </li>
    </ul>
  </div>;
};
